import { useNavigate, useLocation, matchPath } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Compatibility wrapper for the old useHashRouter hook.
 * This allows us to switch to react-router-dom without refactoring every component immediately.
 */
export const useHashRouter = () => {
  const navigateInternal = useNavigate();
  const location = useLocation();

  // The 'route' in the old system was essentially the hash path, e.g. "/market"
  // In HashRouter, location.pathname gives us "/market"
  // So we reconstruct the "route" string to match old expectations if needed,
  // OR we just return the pathname key if components check against strings like This logic might need adjustment based on how components checks it.
  // Checking App.tsx, they checked: route === '/market'.
  // We should normalize it to include the hash prefix for compatibility.
  const route = useMemo(() => location.pathname, [location.pathname]);

  const navigate = (path: string | number) => {
    if (typeof path === 'number') {
      navigateInternal(path as any);
      return;
    }
    let target = path;
    if (path.startsWith('#')) {
      target = path.substring(1);
    }
    navigateInternal(target);
  };

  // Old usage: matchRoute('/listing/:id')
  const matchRoute = (pattern: string) => {
    // pattern e.g. '/listing/:id'
    // internal location.pathname is '/listing/123'
    const match = matchPath(pattern, location.pathname);
    if (!match) return null;
    return match.params as Record<string, string>;
  };

  return { route, navigate, matchRoute, location };
};
